import { render, staticRenderFns } from "./ManualCheckPage.vue?vue&type=template&id=2822df23&scoped=true"
import script from "./ManualCheckPage.vue?vue&type=script&lang=js"
export * from "./ManualCheckPage.vue?vue&type=script&lang=js"
import style0 from "./ManualCheckPage.vue?vue&type=style&index=0&id=2822df23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822df23",
  null
  
)

export default component.exports